import {
    HorizAlignment,
    ISearch,
    ISearchProfile,
    ISearchProvider,
    ISearchProviderField,
    ISearchRequestSubset, ITree,
    SearchProviderFieldType
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PASearch} from "../PA.Core/PASearch";
import {PAEnvironment} from "../PA.Core/PAEnvironment";
import {ColumnNodeProvider} from "../PA.UIM.Core/SearchTreeUtils";

const vUI_Control_Point_Type_Search_Fields: {[id: string]: ISearchProviderField}  = {
    WB_CONTROL_POINTM_ID:     {type: SearchProviderFieldType.number,   renderOptions: { columnName: 'Wb Id',     columnResourceName: 'colwbId',      alignment: HorizAlignment.Left},  domainOptions: {} },
    CONTROL_POINT_TYPE_ID:    {type: SearchProviderFieldType.string,   renderOptions: { columnName: 'Id',        columnResourceName: 'colId',        alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    CONTROL_POINT_TYPE_NAME:  {type: SearchProviderFieldType.string,   renderOptions: { columnName: 'Name',      columnResourceName: 'colName',      alignment: HorizAlignment.Left},  domainOptions: {maxLength: 256}},
    TREE_PATH:                {type: SearchProviderFieldType.string,   renderOptions: { columnName: 'Tree Path', columnResourceName: 'colTreePath',  alignment: HorizAlignment.Left},  domainOptions: {maxLength: 256}},
    ENABLED_IND:              {type: SearchProviderFieldType.boolean,  renderOptions: { columnName: 'Enabled',   columnResourceName: 'colEnabled',   alignment: HorizAlignment.Left},  domainOptions: {maxLength: 1}},
    PLACEMENT_POLICY:         {type: SearchProviderFieldType.string,   renderOptions: { columnName: 'Placement', columnResourceName: 'colPlacement', alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    MANUAL_IND:               {type: SearchProviderFieldType.boolean,  renderOptions: { columnName: 'Manual',    columnResourceName: 'colManual',    alignment: HorizAlignment.Left},  domainOptions: {maxLength: 1}},
    CREATED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Created Date',
            columnResourceName: 'colCreateDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    },
    MODIFIED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Modified Date',
            columnResourceName: 'colModifiedDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    }
};

const ControlPointTypeSearchProviderBasic: ISearchProvider = {

    keyFields: {id:    'WB_CONTROL_POINTM_ID',
        id_ui: 'CONTROL_POINT_TYPE_ID',
        name:  'CONTROL_POINT_TYPE_NAME'

    },

    searchProviderFields: vUI_Control_Point_Type_Search_Fields,

    search(searchRequestSubset: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error)=>{
            let findRequest = SearchUtils.makeSearchRequest(searchRequestSubset,
                'vUI_Control_Point_Type_Search',
                this.searchProviderFields,
                []);

            PASearch.findByRequest(findRequest)
                .then((res: any[])=> {
                    resolve(res)
                })
                .catch((err)=> {
                    error(err)
                });
        })
    }
};

const ControlPointTypeSearchProfileByName: ISearchProfile = {
    profileId: "default",
    profileName: "Search by Id, Name",
    renderOptions: {ui5SourceId: "ControlPointTypeSearchProfileByName"},

    profileFilter: [
        {profileFilterName: 'Id',   searchProviderFieldId:  'CONTROL_POINT_TYPE_ID', renderOptions: {}},
        {profileFilterName: 'Name', searchProviderFieldId: 'CONTROL_POINT_TYPE_NAME', renderOptions: {}}
    ], //ISearchFields
    profileDisplayFields: [
        'CONTROL_POINT_TYPE_ID', 'CONTROL_POINT_TYPE_NAME','ENABLED_IND','PLACEMENT_POLICY','MANUAL_IND', 'CREATED_DTTS', 'MODIFIED_DTTS'
    ],

    profileSearchProvider: ControlPointTypeSearchProviderBasic,

    profileTreeIdDefault: "default",
    profileTrees: [
        {treeId: "default",
            treeName: "By Hierarchy",
            nodeProviders: [ new ColumnNodeProvider(['TREE_PATH'], {defaultValues: "No Parent Set"})],
            renderOptions: {}}
    ],

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
};

const ControlPointTypeSearch: ISearch = {
    searchName: "Find Control Point Type",
    renderOptions: {ui5ResourceId: "ControlPointTypeSearch"},
    searchProfileIdDefault: "default",
    searchProfiles: [ControlPointTypeSearchProfileByName]
};

PAEnvironment.registerBusinessObjectSearch("ControlPointTypeBO", "ControlPointType", ControlPointTypeSearch, "Control Point Type Search")

export {ControlPointTypeSearch}